module.exports = __webpack_public_path__ + "img/home_bgv4.32ed07ba.png";